import { use, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

type ErrorMessage = {
  localErrorMsgTKey: string | null;
};

const useErrorMessage = (): ErrorMessage => {
  const { t } = useTranslation('errorHandling');
  const appInsights = useAppInsightsContext();
  const { errorMsgTKey } = use(ErrorMessageProviderContext);

  const [localErrorMsgTKey, setLocalErrorMsgTKey] = useState<string | null>(null);

  useEffect(() => {
    if (localErrorMsgTKey !== errorMsgTKey) {
      if (errorMsgTKey) {
        appInsights?.trackException({
          error: new Error(`An error message has popped up with the message: ${t(errorMsgTKey)}`),
          severityLevel: SeverityLevel.Warning,
        });
      }

      setLocalErrorMsgTKey(errorMsgTKey);
    }
  }, [errorMsgTKey]);

  return {
    localErrorMsgTKey,
  };
};

export default useErrorMessage;
